export type AppErrorName = 'AppError' | 'FileReaderError' | 'MSALInstanceError'
/**
 * A custom error class that extends the native Error class
 *
 * @export
 * @class AppError
 * @extends {Error}
 */
export class AppError extends Error {
  name: AppErrorName
  message: string
  errorCode: number
  innerError: unknown

  constructor({
    name,
    message,
    errorCode,
    innerError,
  }: {
    name: AppErrorName
    message: string
    errorCode: number
    innerError: unknown
  }) {
    super()
    this.name = name
    this.message = message
    this.errorCode = errorCode
    this.innerError = innerError
  }
}
